define('plugin/invoice/model/InvoicePackageInstanceModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Invoice package instance model
     *
     * @class InvoicePackageInstanceModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: null,
            package: null,
            services: null,
            products: null,
            paid_attributes: null
        }

    });

});
